import React, {memo, useCallback, useState, useMemo} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {LogListType} from "../../../../store/control/state"
import {useRPC} from "../../../../hooks/rpc"
import {useSelector} from "react-redux"
import {downloadStringAsFile} from "../../../../utils/download"

export const Logs = memo(function Logs() {
    const {t} = useLocalization()
    const [rpc] = useRPC()
    const [downloading, setDownloading] = useState(false)
    const logListSelector = useSelector(state => state.control.logList || null)
    const [selectedControl, setSelectedControl] = useState<LogListType>(null)
    let i = logListSelector.length - 1
    const keyExtractor = (item: LogListType) => item[i]

    const downloadLogClick = useCallback(() => {
        if (downloading) {
            return
        }
        setDownloading(true)
        rpc.DownloadLog(selectedControl)
            .then(e => downloadStringAsFile(e, `${selectedControl}`))
            .catch(console.log)
            .finally(() => setDownloading(false))
    }, [downloading, rpc, selectedControl])

    const buttons = useMemo(
        () => [
            {
                text: downloading ? t("downloading") : t("download_log"),
                onClick: downloadLogClick,
                className: "green",
                hidden: !selectedControl
            }
        ],
        [t, selectedControl, downloading, downloadLogClick]
    )

    const displayNameExtractor = useCallback((item: LogListType, column: ColumnModel) => {
        if (column.key === "name") {
            return item
        }
        return item[column.key] || "-"
    }, [])

    const columns = useMemo<ColumnModel[]>(() => [{length: 1, name: t("name"), key: "name"}], [t])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer className="service-edit" buttons={buttons} backUrl="/settings/db" searchable={true}>
                <SettingsList
                    columns={columns}
                    items={logListSelector}
                    keyExtractor={keyExtractor}
                    displayNameExtractor={displayNameExtractor}
                    selectedItem={selectedControl}
                    onItemSelected={setSelectedControl}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
